import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import BuyAgainModel from '../model/BuyAgainModel.js';
/**
 * @method apiGetBuyAgain
 */
export default {
    /**
     * @param {String} token
     */
     apiGetBuyAgain: function (token) {
        var params = {};

        const url = ConfigManager.getApiUrl() + "/payment/recent";
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                console.log('res',res)
                var campaign = [];
                for (var i of res.data) {
                    var objCampaign = new BuyAgainModel(i);
                    campaign.push(objCampaign);
                }

                return campaign;
            }));
    },
}
